export default __webpack_public_path__ + "static/media/l.d12207f6.png";